import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Toggle.css";

const ToggleSwitch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSongs = location.pathname === "/songs";

  const handleToggle = () => {
    navigate(isSongs ? "/shows" : "/songs");
  };

  return (
    <div className="toggle-wrapper">
      <button
        type="button"
        className="mode-pill"
        onClick={handleToggle}
      >
        <span className={!isSongs ? "pill-active" : ""}>SHOWS</span>
        <span className={isSongs ? "pill-active" : ""}>SONGS</span>
      </button>
    </div>
  );
};

export default ToggleSwitch;
